<template>
  <div class="main">
    <c-panel title="Estoque de Alimentos" titleIcon="fas fa-warehouse">
      <el-form label-position="top" class="u-mt-10 u-mb-10" v-if="exibeSelectInstituicao">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="24" :md="24">
            <el-form-item>
              <el-select @change="changeInstituicao" v-model="filtro.instituicao.id" filterable placeholder="Pesquisar Instituição">
                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-row :gutter="10" class="u-mt-10 u-mb-10">
        <el-col :xs="24" :sm="12" :md="12">
          <el-input v-model="filtro.nome" placeholder="Pesquisar alimento" @keyup.native.enter="load"></el-input>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" class="u-text-right">
          <el-button @click="load" type="info" plain icon="el-icon-search">FILTRAR</el-button>
        </el-col>
      </el-row>

      <el-row :gutter="10" class="u-mb-10">
        <el-col :xs="24" :sm="12" :md="12">
          <c-panel title="Próximos do vencimento (15 dias)" titleIcon="fas fa-exclamation-triangle">
            <div class="container-table">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Alimento</th>
                    <th style="width: 110px;">Validade</th>
                    <th style="width: 90px; text-align:right;">Qtd</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, idx) in alertas.proximos" :key="'p'+idx">
                    <td>{{ i.nome }}</td>
                    <td>{{ i.validade ? formatDate(i.validade) : '-' }}</td>
                    <td style="text-align:right;">{{ formatNumber(i.quantidade, 3) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </c-panel>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12">
          <c-panel title="Vencidos" titleIcon="fas fa-times-circle">
            <div class="container-table">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Alimento</th>
                    <th style="width: 110px;">Validade</th>
                    <th style="width: 90px; text-align:right;">Qtd</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(i, idx) in alertas.vencidos" :key="'v'+idx">
                    <td>{{ i.nome }}</td>
                    <td>{{ i.validade ? formatDate(i.validade) : '-' }}</td>
                    <td style="text-align:right;">{{ formatNumber(i.quantidade, 3) }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </c-panel>
        </el-col>
      </el-row>

      <div class="container-table">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Alimento</th>
              <th class="hidden-mobile">Categoria</th>
              <th style="width: 90px;">Unid.</th>
              <th style="width: 140px; text-align:right;">Entrada</th>
              <th style="width: 140px; text-align:right;">Saída</th>
              <th style="width: 140px; text-align:right;">Saldo</th>
            </tr>
          </thead>
          <tbody v-if="statusList">
            <tr v-for="(item, idx) in items" :key="idx">
              <td>{{ item.nome }}</td>
              <td class="hidden-mobile">{{ item.categoria || '-' }}</td>
              <td>{{ item.unidade_medida || '-' }}</td>
              <td style="text-align:right;">{{ formatNumber(item.total_entrada, 3) }}</td>
              <td style="text-align:right;">{{ formatNumber(item.total_saida, 3) }}</td>
              <td style="text-align:right;">{{ formatNumber(item.quantidade_atual, 3) }}</td>
            </tr>
          </tbody>
        </table>

        <div v-if="!statusList" class="u-text-center u-mt-25">
          <img src="/public/img/loading-bar.gif" />
        </div>
      </div>
    </c-panel>
  </div>
</template>

<script>
export default {
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    statusList: false,
    filtro: {
      instituicao_id: '',
      instituicao: { id: '', nome: '' },
      nome: ''
    },
    items: [],
    alertas: { proximos: [], vencidos: [] }
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    if (this.$store.state.config.instituicao) {
      this.filtro.instituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
    this.load()
  },
  methods: {
    async changeInstituicao () {
      if (this.exibeSelectInstituicao) {
        await this.$store.dispatch('setInstituicao', this.filtro.instituicao.id)
      }
      this.load()
    },
    async load () {
      this.statusList = false
      this.items = []
      this.filtro.instituicao_id = this.$store.state.config.instituicao ? this.$store.state.config.instituicao.id : ''
      try {
        const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/estoque/getAllPaginate`, this.filtro, this.$store.getters.getHeaderAuth)
        this.items = res.data.data || res.data || []
        this.statusList = true
        const al = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/estoque/alertas-validade`, { instituicao_id: this.filtro.instituicao_id, dias: 15 }, this.$store.getters.getHeaderAuth)
        this.alertas = al.data || { proximos: [], vencidos: [] }
      } catch (e) {
        this.$store.commit('throwException', e)
      }
    },
    formatDate (d) {
      const dt = new Date(d + 'T00:00:00')
      return dt.toLocaleDateString('pt-BR')
    },
    formatNumber (v, decimals = 2) {
      const n = Number(v || 0)
      return n.toLocaleString('pt-BR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    }
  }
}
</script>

